/**
 * Created by JurY on 16/06/17.
 */

angular.module("screensApp")

  .controller("VirtualsController", function ($scope, $rootScope) {
    $rootScope.showVirtuals = function (data) {
      window.removeEventListener("message", listenerVTIIframe, false);

      //  Show container
      $rootScope.vgURL = $scope.virtualGame = "";
      $rootScope.settings.winnersForBanner = false;

      switch (data.leagueID) {
        // Betradar (UOF)
        case 602501:
          // UOF Soccer Majstrovstva sveta (VFWC)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602501&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vflive.aitcloud.de/vfwcterminal/retail/index?clientid=2003&lang=sk&style=doxxbdefterm&screen=doxxbet_terminal_vfwc_main_screen_fullscreen_match";
          break;
        case 629326:
          // UOF Soccer Doxxbet liga (VFLM) (Nove ID Doxxbet ligy) STG:
          // $rootScope.vgURL = "https://vfstaging.aitcloud.de/vflmterminalstaging/retail/index?clientid=2003&screen=doxxbet_terminal_vflm_main_screen_fullscreen_match&style=doxxbetterm&lang=sk&channel=0";
        case 610559:
          // UOF Soccer Doxxbet liga (VFLM) (Nove ID Doxxbet ligy) PROD:
          // $rootScope.vgURL = "https://vflive.aitcloud.de/vflmterminal/retail/index?clientid=2003&style=doxxbdefterm&screen=doxxbet_terminal_vflm_main_screen_fullscreen_match&lang=sk&channel=0";
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=" + data.leagueID + "&language=" + $rootScope.config.LanguageId;
          break;
        case 602500:
          // UOF Soccer Bundesliga (VFB)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602500&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vgfrontendstaging.aitcloud.de/vsfrontend/?clientid=2003&sport=vfb&platform=retail&product=vfb&style=doxxbdefterm&screen=Doxxbet/terminal_vfb_main_screen_fullscreen_match&oddType=dec&language=sk&channel=0";
          break;
        case 602502:
          // UOF Soccer Liga majstrov (VFCC)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602502&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vgfrontendlive.aitcloud.de/vsfrontend/?clientid=2003&sport=vfcc&platform=retail&product=vfcc&style=doxxbdefterm&language=sk&channel=0&screen=Doxxbet/terminal_vfcc_main_screen_fullscreen_match";
          break;
        case 602714:
          // UOF Basketbal Betradar (VBL)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602714&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vbllive.aitcloud.de/vblshop/terminal/index?clientid=2003&lang=sk&style=doxxbdefshop";
          break;
        case 602577:
          // UOF Horses (VHC)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602577&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vhc20live.aitcloud.de/vhcshop/retail/1920/clientid:2003/lang:en/channel:0/style:doxxbfullscreen";
          break;
        case 602578:
          // UOF Greyhounds (VDR)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=602578&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://vdrlive.aitcloud.de/vdrshop/retail/1920/clientid:2003/lang:en/channel:0/style:doxxbfullscreen";
          break;
        case 598830:
          // UOF Tenis Virtual Tenis Inplay (VTI)
          $rootScope.vgURL = $rootScope.url.AppWidgetURL + "virtual-games-player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=598830&language=" + $rootScope.config.LanguageId;
          // $rootScope.vgURL = "https://virtualgames-cf.doxxbet.sk/vtidxb/vti/index?clientid=2003&pathprefix=off&style=doxxbetvideo&lang=en";
          $scope.virtualGame = "vti";
          break;

        // Kiron (KRN)
        case 607002:
          // KRN Greyhounds Platinum Hounds
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd30-7efc-710a-af63-98a449708d53";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607002&language=" + $rootScope.config.LanguageId;
          break;
        case 607003:
          // KRN Horses Dashing Derby
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd32-c564-705d-b5a2-356445049d1d";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607003&language=" + $rootScope.config.LanguageId;
          break;
        case 607007:
          // KRN Soccer English Football League Game
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd34-3908-732a-9f8d-fb53e5f86ba1";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607007&language=" + $rootScope.config.LanguageId;
          break;
        case 607008:
          // KRN Soccer English Football Single Game
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd34-bf2c-7322-9b6a-664e5442486f";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607008&language=" + $rootScope.config.LanguageId;
          break;
        case 607009:
          // KRN Soccer Spanish Football League Game
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd09-75bc-72f0-9d07-4dd077efec97";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607009&language=" + $rootScope.config.LanguageId;
          break;
        case 607010:
          // KRN Soccer Italian Football League Game
          $rootScope.vgURL = $rootScope.url.KironURL + "0199dd0a-cbfc-72d2-9c2b-b6e5a8f8cc03";
          // $rootScope.vgURL = $rootScope.url.AppWidgetURL + "mobile/vg/player/" + $rootScope.url.AppWidgetVersionVG + "&leagueID=607010&language=" + $rootScope.config.LanguageId;
          break;
        case 606998:
          // KRN Hockey Majstrovstva sveta
          $rootScope.vgURL = "virtuals/kiron-hockey-hls.html";
          break;
        default:
          // Zatvori virtualne hry
          $rootScope.hideVirtualsEvona();
          $rootScope.hideVirtuals();

          $rootScope.$$phase || $rootScope.$apply();
          break;
      }

      if (data.channelID) {
        $rootScope.vgURL = $rootScope.vgURL + "&channelid=" + data.channelID;
      }

      $rootScope.settings.virtuals.show = true;
      $rootScope.settings.virtuals.active = true;

      if ($scope.virtualGame === "vti") {
        window.addEventListener("message", listenerVTIIframe, false);
      }
      $rootScope.createLogForStreamMedia("VG", $rootScope.settings.virtuals.show);

      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showVirtuals() data: ' + JSON.stringify(data) + ' vgURL: ' + $rootScope.vgURL);

      $rootScope.$$phase || $rootScope.$apply();
    };

    // Listen VTI Iframe for first match
    listenerVTIIframe = function (data) {
      if (data.data.length) {
        payload = JSON.parse(data.data);
        // Normalize URLs by removing trailing slash for comparison
        var normalizedOrigin = data.origin.replace(/\/$/, '');
        var normalizedAppWidgetURL = $rootScope.url.AppWidgetURL.replace(/\/$/, '');
        if (normalizedOrigin === normalizedAppWidgetURL && payload.messageType === "switchEvents" && payload.messageData && payload.messageData.event_ids.length) {
          // Listen just switching of eventID, send it to bottom app
          $rootScope.BottomScreen("firstVirtualLiveFeedReference", {
            eventID: payload.messageData.event_ids[0],
            initiator: "screensApp"
          });
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: listenerVTIIframe() messageType: ' + JSON.stringify(payload.messageType));
        }
      }
    };

    // Hide VirtualsContainer
    $rootScope.hideVirtuals = function () {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideVirtuals() { actionFromUser }');
        window.removeEventListener("message", listenerVTIIframe, false);
        $rootScope.vgURL = getDefaultBannerRelativePath();
        $rootScope.settings.virtuals.active = false;
        $rootScope.settings.virtuals.show = false;
        $rootScope.createLogForStreamMedia("VG", $rootScope.settings.virtuals.show);
      $rootScope.$$phase || $rootScope.$apply();
    };
  });
